export default __webpack_public_path__ + "static/media/javascript.37683312.jpg";